import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGeneratorHeroCard from '../components/ResponseBlockGeneratorHeroCard';
import { gAPI_Response_HHAssistantOptions } from '../../../../../constants/APIs';

export default class HolidayHomesAssistantOptions extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGeneratorHeroCard getUrl={gAPI_Response_HHAssistantOptions} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
